import { plainToInstance, Type } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { ProjectTargetResult } from '@core/entities/notifications/ProjectTargetResult'
import { TemplateTargetResult } from '@core/entities/notifications/TemplateTargetResult'
import { IChecklistTargetResult } from './IChecklistTargetResult'

export class ChecklistTargetResult extends Entity<IChecklistTargetResult> {
  id: number
  organisationId: number
  shortUUID: string
  isInspection: boolean
  summary?: string
  outcome?: 'PASS' | 'FAIL'

  @Type(() => ProjectTargetResult)
  project?: ProjectTargetResult

  @Type(() => TemplateTargetResult)
  template?: TemplateTargetResult

  public static new(payload: IChecklistTargetResult): ChecklistTargetResult {
    return plainToInstance(ChecklistTargetResult, payload)
  }
}
